import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ContentContainer, SwellEventCardContainer } from '@surfline/quiver-react';
import { loadTreatment, trackNavigatedToPage, trackEvent } from '@surfline/web-common';
import HomeCam from '../../../components/HomeCam';
import HomepageHelmet from '../../../components/HomepageHelmet';
import PopularLinks from '../../../components/PopularLinks';
import Feed from '../../Feed';
import { fetchBrowserData } from '../../../actions/browser';
import { fetchPromoBoxSlides, fetchFeed } from '../../../actions/homepage';
import {
  setHomeCam,
  selectHomeCamOption,
  toggleHomeCamSelectView,
  toggleHomeCamVisibility,
  updateHomeCam,
} from '../../../actions/homecam';
import { fetchSwellEvents } from '../../../actions/swellEvents';

import {
  getBasicStatus,
  getPremiumStatus,
  getUserFavorites,
  getUserSettings,
} from '../../../selectors/user';
import { getBrowserData } from '../../../selectors/browser';
import getSwellEvents from '../../../selectors/swellEvents';
import browserDataPropShape from '../../../propTypes/browserData';
import homeCamPropType from '../../../propTypes/homecam';
import swellEventsPropType from '../../../propTypes/swellEvents';
import userFavoritesPropType from '../../../propTypes/userFavorites';
import userSettingsPropType from '../../../propTypes/userSettings';
import config from '../../../config';
import { SL_LOCALIZED_FEED } from '../../../common/treatments';

class Homepage extends Component {
  componentDidMount() {
    const { doFetchSwellEvents, doSetHomeCam, doToggleHomeCamVisibility } = this.props;

    let userType = null;
    const { isBasic, isPremium } = this.props;
    if (isBasic) userType = 'sl_basic';
    else if (isPremium) userType = 'sl_premium';

    trackNavigatedToPage('Home', {
      userType,
      category: 'home',
      channel: 'home',
      subCategory: 'personalized',
    });

    doSetHomeCam();
    doToggleHomeCamVisibility(true);
    doFetchSwellEvents();
  }

  onClickCard = (swellEvent) => {
    trackEvent('Clicked Swell Alert Card', {
      title: swellEvent.name,
      contentType: 'Swell Alert',
      basins: swellEvent.basins.join(','),
      locationCategory: 'Homepage - Top',
      destinationUrl: swellEvent.permalink,
    });
  };

  render() {
    const {
      isPremium,
      homecam,
      userFavorites,
      userSettings,
      doSelectHomeCamOption,
      doToggleHomeCamVisibility,
      doToggleHomeCamSelectView,
      doUpdateHomeCam,
      browserData,
      location,
      swellEvents,
    } = this.props;

    return (
      <div className="sl-homepage">
        <HomepageHelmet title={config.meta.title.homepage} />
        {homecam.initialLoad ? (
          <HomeCam
            homecam={homecam}
            isPremium={isPremium}
            userFavorites={userFavorites}
            userSettings={userSettings}
            doSelectHomeCamOption={doSelectHomeCamOption}
            doToggleHomeCamSelectView={doToggleHomeCamSelectView}
            doToggleHomeCamVisibility={() => doToggleHomeCamVisibility()}
            doUpdateHomeCam={doUpdateHomeCam}
            browserData={browserData}
          />
        ) : null}
        {swellEvents.length ? (
          <ContentContainer>
            <SwellEventCardContainer
              events={swellEvents}
              onClickCard={(swellEvent) => this.onClickCard(swellEvent)}
            />
          </ContentContainer>
        ) : null}
        <Feed qaFlag={location.query && location.query.qaFlag} />
        <ContentContainer>
          <PopularLinks />
        </ContentContainer>
      </div>
    );
  }
}

Homepage.fetch = [
  () => async (dispatch) => {
    // onboarding is injected into state from the root container before this
    // function is executed
    await Promise.all([
      dispatch(loadTreatment(SL_LOCALIZED_FEED)),
      dispatch(fetchPromoBoxSlides()),
      dispatch(fetchFeed()),
    ]);
  },
  (_, { headers }) => fetchBrowserData(headers),
];

Homepage.propTypes = {
  homecam: homeCamPropType,
  doFetchSwellEvents: PropTypes.func.isRequired,
  doSetHomeCam: PropTypes.func.isRequired,
  doSelectHomeCamOption: PropTypes.func.isRequired,
  doToggleHomeCamSelectView: PropTypes.func.isRequired,
  doToggleHomeCamVisibility: PropTypes.func.isRequired,
  doUpdateHomeCam: PropTypes.func.isRequired,
  isBasic: PropTypes.bool.isRequired,
  isPremium: PropTypes.bool.isRequired,
  userFavorites: userFavoritesPropType,
  userSettings: userSettingsPropType,
  browserData: browserDataPropShape.isRequired,
  location: PropTypes.shape({
    query: PropTypes.shape({
      qaFlag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }),
  }).isRequired,
  swellEvents: swellEventsPropType,
};

Homepage.defaultProps = {
  homecam: {
    visible: true,
    camera: null,
  },
  swellEvents: [],
  userFavorites: [],
  userSettings: {
    homecam: null,
  },
};

export default connect(
  (state) => ({
    userFavorites: getUserFavorites(state),
    userSettings: getUserSettings(state),
    isBasic: getBasicStatus(state),
    isPremium: getPremiumStatus(state),
    homecam: state.homecam,
    browserData: getBrowserData(state),
    swellEvents: getSwellEvents(state),
  }),
  (dispatch) => ({
    doSetHomeCam: () => dispatch(setHomeCam()),
    doSelectHomeCamOption: (value) => dispatch(selectHomeCamOption(value)),
    doToggleHomeCamSelectView: () => dispatch(toggleHomeCamSelectView()),
    doToggleHomeCamVisibility: (value) => dispatch(toggleHomeCamVisibility(value)),
    doUpdateHomeCam: () => dispatch(updateHomeCam()),
    doFetchSwellEvents: () => dispatch(fetchSwellEvents()),
  })
)(Homepage);
